import { render, staticRenderFns } from "./base-file.vue?vue&type=template&id=188cb8ac&"
import script from "./base-file.vue?vue&type=script&lang=js&"
export * from "./base-file.vue?vue&type=script&lang=js&"
import style0 from "./base-file.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFileInput } from 'vuetify/lib/components/VFileInput';
installComponents(component, {VFileInput})
